<template>
    <section class="py-16 lg:py-[150px] px-5 lg:px-[120px]" :class="backgroundColor">
        <div class="mx-auto">
            <div class="grid xl:grid-cols-2 gap-[50px] items-center">
                <div :class="position === 'right' ? 'order-2' : 'order-1'">
                    <div v-if="!image" class="relative w-full xs:h-[250px] md:h-[450px] xl:h-[323px] h-[200px] mx-auto">
                        >
                        <iframe
                            :src="videoUrl"
                            loading="lazy"
                            style="border: 0; position: absolute; top: 0; height: 100%; width: 100%"
                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                            allowfullscreen="true"
                            class="rounded-lg"
                        ></iframe>
                    </div>
                    <div v-if="image" class="relative w-full lg:h-[575px] h-[350px] mx-auto">
                        <img :src="image" class="rounded-2xl object-cover w-full h-full" alt="" />
                    </div>
                </div>
                <div class="" :class="position === 'right' ? 'order-1' : 'order-2'">
                    <h2 class="text-[28px] md:text-[44px] lg:text-[44px] lg:leading-[57px] font-semibold mb-[50px]" :class="titleColor">
                        <span v-html="renderTitle()"></span>
                    </h2>
                    <p :class="textColor" class="font-pro text-[18px]" v-html="content"></p>

                    <router-link
                        v-if="ctaText"
                        :to="ctaLink"
                        class="px-4 py-4 mt-6 rounded-full font-bold text-md inline-flex items-center gap-2 transition text-white hover:opacity-90 w-full justify-center lg:w-fit text-center"
                        :style="{ background: `linear-gradient(to bottom right, ${buttonGradientFrom}, ${buttonGradientTo})` }"
                    >
                        {{ ctaText }}
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    backgroundColor: {
        type: String,
        default: '#FFFFFF'
    },
    title: {
        type: String,
        default: ''
    },
    titleHighlight: {
        type: String,
        default: ''
    },
    titleHighlightGradientFrom: {
        type: String,
        default: '#11D2D4'
    },
    titleHighlightGradientTo: {
        type: String,
        default: '#0C7475'
    },
    titleColor: {
        type: String,
        default: 'text-blue-dark'
    },
    content: {
        type: String,
        default: ''
    },
    textColor: {
        type: String,
        default: 'text-gray-700'
    },
    videoUrl: {
        type: String,
        default: ''
    },
    height: {
        type: Number,
        default: 384
    },
    position: {
        type: String,
        default: 'left',
        validator: (value) => ['left', 'right'].includes(value)
    },
    ctaLink: {
        type: String,
        default: '/'
    },
    ctaText: {
        type: String,
        default: ''
    },
    buttonGradientFrom: {
        type: String,
        default: '#11D2D4'
    },
    buttonGradientTo: {
        type: String,
        default: '#0C7475'
    },
    image: {
        type: String,
        default: ''
    }
});

const renderTitle = () => {
    if (!props.titleHighlight) return props.title;

    const highlightRegex = new RegExp(`(${props.titleHighlight})`, 'g');

    return props.title.replace(
        highlightRegex,
        `<span class="bg-gradient-to-t text-transparent bg-clip-text" style="background: linear-gradient(to top, ${props.titleHighlightGradientFrom}, ${props.titleHighlightGradientTo}); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">$1</span>`
    );
};
</script>
